import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { AuthService } from './services/auth';
import { ConfigServerService, initConfigServer } from './services/config';
import { CustomHttp, customHttpFactory, DefaultHeadersInterceptor, HttpErrorInterceptor } from './services/http';
import { NavigationService, navigationServiceFactory } from './services/navigation';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { DndModule } from 'ng2-dnd';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

/**
 * Module de providres singletons, ou seja, que devem possuir uma única instância para a aplicação toda
 */
@NgModule({
    imports: [
        HttpClientModule,
        PopoverModule.forRoot(),
        TimepickerModule.forRoot(),
        TypeaheadModule.forRoot(),
        DndModule.forRoot(),
        CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory })
    ],
    providers: [
        {provide: APP_INITIALIZER, useFactory: initConfigServer, deps: [ConfigServerService], multi: true}, // Config Service
        {provide: APP_INITIALIZER, useFactory: navigationServiceFactory, deps: [NavigationService], multi: true}, // Navigation Service
        {provide: HTTP_INTERCEPTORS, useClass: DefaultHeadersInterceptor, multi: true}, // HTTP Interceptor
        {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true}, // HTTP Error Interceptor
        {provide: CustomHttp, useFactory: customHttpFactory, deps: [HttpClient, AuthService]} // Custom HTTP Client
    ]
})
export class CoreModule {
     constructor(@Optional() @SkipSelf() parenteModule: CoreModule) {
        throwIfAlreadyLoaded(parenteModule, 'CoreModule');
    }
}
